import { CREATE_CONFIGURATION_ENDPOINT } from '../const';
import { isKazakhstanRegion } from '../../../common/helpers/is-kazakhstan-region';
import { getCreateConfigurationBody } from './get-create-configuration-body';
import { TData } from '../../../entries/common/widgets/context';

type TParams = {
  data: TData;
  inputParameters: {
    layerThickness?: number | null;
    height?: number | null;
    width?: number | null;
    length?: number | null;
    areaUser?: number | null;
  };
  thickness: string | null;
  authorizedCustomerId: string | undefined;
  unauthorizedCustomerId: string | undefined;
};

export const createConfiguration = ({
  data,
  inputParameters,
  thickness,
  authorizedCustomerId,
  unauthorizedCustomerId,
}: TParams) => {
  try {
    const isKazakhstan = isKazakhstanRegion(data.regionId);
    const createConfigurationBody = getCreateConfigurationBody({
      authorizedCustomerId,
      unauthorizedCustomerId,
      isKazakhstan,
      inputParams: inputParameters,
      calculatorId: data.surfaces.id,
      typeInstallation: thickness,
    });
    data.api.post(`${CREATE_CONFIGURATION_ENDPOINT}`, createConfigurationBody);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('create room failed', e);
  }
};
